// For full API documentation, including code examples, visit http://wix.to/94BuAAs

import {local} from 'wix-storage';

import wixLocation from 'wix-location';

 

$w.onReady(function () {

});

 

export function searchButton_click() {

    let word = $w("#searchbar").value;

    local.setItem("searchWord", word);

    wixLocation.to(`/search-results`);

}
